import { z } from 'zod';
import { UserRoleSchema } from './auth';

export const InviteUserSchema = z.object({
  email: z.string().email().max(254),
  role: UserRoleSchema,
  // Legacy combined name — kept for older clients that still POST it.
  name: z.string().min(1).max(120).optional(),
  firstName: z.string().min(1).max(80).optional(),
  lastName: z.string().min(1).max(80).optional(),
});
export type InviteUser = z.infer<typeof InviteUserSchema>;

export const ListUsersQuerySchema = z.object({
  includeRevoked: z.coerce.boolean().default(false),
});
export type ListUsersQuery = z.infer<typeof ListUsersQuerySchema>;

export const AllowlistEntrySchema = z.object({
  id: z.string().guid(),
  email: z.string().email(),
  role: UserRoleSchema,
  invitedBy: z.string().guid().nullable(),
  revokedAt: z.string().datetime().nullable(),
  createdAt: z.string().datetime(),
  hasLoggedIn: z.boolean(),
  userId: z.string().guid().nullable(),
  /** Legacy combined name — only present if the user filled it on a previous app version. */
  name: z.string().nullable(),
  /** Effective first name: user.firstName if logged in, otherwise allowlist.firstName from invite. */
  firstName: z.string().nullable(),
  /** Effective last name: same fallback chain as firstName. */
  lastName: z.string().nullable(),
});
export type AllowlistEntry = z.infer<typeof AllowlistEntrySchema>;

export const UpdateUserRoleSchema = z.object({
  role: UserRoleSchema,
});
export type UpdateUserRole = z.infer<typeof UpdateUserRoleSchema>;
